// import { Router } from '@angular/router';
// //httpConfig.interceptor.ts
// import {
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpInterceptor,
//   HttpResponse,
//   HttpErrorResponse
// } from '@angular/common/http';
// import { Observable, of, throwError } from 'rxjs';
// import { map, catchError } from 'rxjs/operators';
// import { Injectable } from '@angular/core';

// @Injectable()
// export class HttpConfigInterceptor implements HttpInterceptor {
//   loaderToShow: any;
//   constructor(
//     private _Router:Router
//     ) { }

//     private handleAuthError(err: HttpErrorResponse): Observable<any> {
//       //handle your auth error or rethrow
//       if(err.status === 403) {
//           this._Router.navigateByUrl(`/login`);
//           return of(err); // or EMPTY may be appropriate here
//       }
//       return throwError(err);
//   }

//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

//     const token = localStorage.getItem('token');
//     // const companyId =  localStorage.getItem("companyId");
//     const userId = localStorage.getItem("user_id");

//     //Authentication by setting header with token value
//     if(token) {
//       request = request.clone({
//         setHeaders: {
//           'Authorization':'Bearer '+ token,
//           // 'companyId': companyId,
//            'user_id': userId,
//           // 'Content-Type': 'application/json'
//         }
//       });
//     }

//     // if (!request.headers.has('Content-Type')) {
//     //   request = request.clone({
//     //     setHeaders: {
//     //       'content-type': 'application/json'
//     //     }
//     //   });
//     // }

//     // request = request.clone({
//     //   headers: request.headers.set('Accept', 'application/json')
//     // });
//       // this.ngxLoader.start();
//       return next.handle(request).pipe(
//         map((event: HttpEvent<any>) => {
//           if(event instanceof HttpResponse) {

//           }
//           // this.ngxLoader.stop();
//           return event;
//         }),
//         catchError((error: HttpErrorResponse) => {

//        //  this.ngxLoader.stop();
//        this.handleAuthError(error);

//        return throwError(error);
//       }));

//   }

// }

import { Router } from "@angular/router";
// httpConfig.interceptor.ts
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AuthorityConnectionService } from "../services/authority-connection.service";
import { AuthService } from "../Auth/service/auth.service";
import { isUnistructService401 } from "../services/unistruct.service";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  loaderToShow: any;
  curentLang: string = "";
  /** Prevents showing multiple session-expired toasts when several requests fail with 401 at once */
  private static sessionExpiredToastShown = false;
  private static readonly DEVICE_ID_STORAGE_KEY = "device_id";

  constructor(
    private _Router: Router,
    private toastr: ToastrService,
    private authorityConnection: AuthorityConnectionService,
    private authService: AuthService
  ) {
    this.curentLang = localStorage.getItem("curentLang") || "en";
  }

  // دالة لمعالجة خطأ الجلسة المنتهية
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // 404 = المصلحة التجارية لم تربط بعد، 406 = انتهت صلاحية الربط (~90 يوم)
    if (
      (err.status === 404 || err.status === 406) &&
      err?.url &&
      err.url.includes("/invoice")
    ) {
      let companyId: number = 0;
      try {
        const storedId = localStorage.getItem("companyId");
        companyId = storedId ? Number(storedId) : 0;
      } catch {}
      if (!companyId && err?.error?.companyId) {
        companyId = Number(err.error.companyId) || 0;
      }
      if (!companyId && (window as any).documentForm) {
        try {
          const docForm = (window as any).documentForm;
          const docCompanyId = docForm.get("head")?.get("company_id")?.value;
          if (docCompanyId) companyId = Number(docCompanyId) || 0;
        } catch (e) {}
      }
      this.authorityConnection.showBanner(companyId, err?.error?.message || "", err.status);
      return throwError(err);
    }
    if (err.status === 401) {
      const url = err?.url || "";
      // Push-device misconfig must not tear down a valid session.
      if (url.includes("/users/push-device") || isUnistructService401(err)) {
        return throwError(() => err);
      }
      if (!HttpConfigInterceptor.sessionExpiredToastShown) {
        HttpConfigInterceptor.sessionExpiredToastShown = true;
        this.showSessionExpiredToast();
      }
      void this.authService.endSession({ redirectTo: '/login' });
      return of(err);
    }
    return throwError(err);
  }

  /** Call this after successful login to allow the session-expired toast to show again on next expiry */
  static resetSessionExpiredToastFlag(): void {
    HttpConfigInterceptor.sessionExpiredToastShown = false;
  }

  // دالة لإظهار رسالة انتهاء الجلسة باستخدام Toast
  private showSessionExpiredToast() {
    this.toastr.warning(
      this.curentLang === "ar"
        ? "لقد انتهت جلستك. يرجى تسجيل الدخول مرة أخرى لمتابعة استخدام النظام."
        : this.curentLang === "en"
        ? "Your session has expired. Please log in again to continue using the system."
        : "המושב שלך פג תוקף. אנא התחבר מחדש כדי להמשיך להשתמש במערכת.",
      "Warning"
    );
  }

  // دالة لإضافة التوكن إلى الهيدر
  private addTokenToRequest(request: HttpRequest<any>): HttpRequest<any> {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id") || "";

    const deviceId = this.getOrCreateDeviceId();
    let headers = request.headers.set("X-Device-ID", deviceId);

    if (token) {
      headers = headers
        .set("Authorization", "Bearer " + token)
        .set("user_id", userId);
    }

    // Multipart: never force Content-Type — the browser must set boundary on the wire.
    if (request.body instanceof FormData) {
      headers = headers.delete("Content-Type");
    }

    return request.clone({ headers });
  }

  private getOrCreateDeviceId(): string {
    try {
      const existing = localStorage.getItem(HttpConfigInterceptor.DEVICE_ID_STORAGE_KEY);
      if (existing && existing.trim()) return existing.trim();
      const newId = this.generateDeviceId();
      localStorage.setItem(HttpConfigInterceptor.DEVICE_ID_STORAGE_KEY, newId);
      return newId;
    } catch {
      return this.generateDeviceId();
    }
  }

  private generateDeviceId(): string {
    // Prefer crypto.randomUUID when available (modern browsers)
    try {
      const c: any = (globalThis as any).crypto;
      if (c && typeof c.randomUUID === "function") return c.randomUUID();
    } catch {}
    // Fallback: RFC4122-ish UUID v4
    const hex = "0123456789abcdef";
    let out = "";
    for (let i = 0; i < 36; i++) {
      if (i === 8 || i === 13 || i === 18 || i === 23) {
        out += "-";
      } else if (i === 14) {
        out += "4";
      } else if (i === 19) {
        out += hex[(Math.random() * 4 + 8) | 0];
      } else {
        out += hex[(Math.random() * 16) | 0];
      }
    }
    return out;
  }

  // دالة interceptor لمعالجة الطلبات
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = this.addTokenToRequest(request);

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // If backend returns a 200 with a body.status === 405 for invoice endpoints,
          // treat it the same as a suppressed 405: mark payload and set transient flag
          try {
            const url = request && request.url ? request.url : "";
            const isInvoiceEndpoint = url.includes("/invoice");
            const body: any = (event as HttpResponse<any>).body;
            const bodyStatusIs405 =
              body && (body.status === 405 || body?.error?.status === 405);
            if (isInvoiceEndpoint && bodyStatusIs405) {
              const rawBody = body || {};
              const newBody = {
                ...rawBody,
                status: 200,
                _suppressedInvoice405: true,
              };
              try {
                (window as any).__suppressInvoice405Swal = true;
                setTimeout(() => {
                  (window as any).__suppressInvoice405Swal = false;
                }, 1500);
              } catch (e) {
                // ignore
              }
              // Return a cloned HttpResponse with modified body
              return (event as HttpResponse<any>).clone({ body: newBody });
            }
          } catch (e) {
            // ignore and fall through to return original event
            console.warn(
              "[HttpConfigInterceptor] Error while normalizing successful 405-like response",
              e
            );
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // استدعاء الدالة لمعالجة الأخطاء
        return this.handleAuthError(error);
      })
    );
  }
}
